import { fieldsToFilter } from "modules/quote";
import { Quote, QuoteFormValues } from "modules/quote/types";
import { QuoteFeeType, QuoteAftermarketProductType } from "@trnsact/trnsact-shared-types";

export function quoteWithEquipment(quote: Quote, equipmentId: string): Quote {
  const filteredQuote = { ...quote };

  fieldsToFilter.forEach(field => {
    if (field === "fees") {
      filteredQuote[field] = Object.values(QuoteFeeType)
        .filter(type => type !== QuoteFeeType.Other)
        .map(type => {
          const equipmentValue = filteredQuote[field].find(
            quoteValue => quoteValue.equipmentId === equipmentId && quoteValue.type === type
          );

          if (equipmentValue) return equipmentValue;
          return { type, amount: 0, equipmentId, description: "" };
        });
    }

    if (field === "aftermarketProducts") {
      filteredQuote[field] = Object.values(QuoteAftermarketProductType)
        .filter(type => type !== QuoteAftermarketProductType.Other)
        .map(type => {
          const equipmentValue = filteredQuote[field].find(
            quoteValue => quoteValue.equipmentId === equipmentId && quoteValue.type === type
          );

          if (equipmentValue) return equipmentValue;
          return { type, cost: 0, equipmentId, description: "" };
        });
    }

    filteredQuote[field] = filteredQuote[field].filter(item => item.equipmentId === equipmentId) as any;
  });

  return filteredQuote;
}

export function mapQuoteWithUpdatedEquipmentData(initialQuote: Quote, changedQuote: QuoteFormValues): Quote {
  const updatedQuote: Quote = { ...initialQuote };

  fieldsToFilter.forEach(field => {
    const targetEquipmentId = changedQuote[field][0]?.equipmentId;
    const data = updatedQuote[field].filter(({ equipmentId }) => equipmentId !== targetEquipmentId);

    updatedQuote[field] = [...data, ...changedQuote[field]] as any;
  });

  return updatedQuote;
}
